import { Link } from "react-router-dom";
import { Handshake, ArrowRight } from "lucide-react";
import CustomFooter from "../component/Footer/customFooter";
import HeaderMenu from "../component/Navbar/headermenu";
import { partnersServices } from "../data/data-six";
import { corporateServices2 } from "../data/dataTwo";
import { Helmet } from "react-helmet-async";
import "./Partners.css";

const Partners = () => {
  return (
    <>
      <Helmet>
        <title>Partners | Simplifyte</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta property="og:title" content="Partners | Simplifyte" />
        <meta
          name="description"
          property="og:description"
          content="Join our mission to simplify how the world works — one team at a time."
        />
        <link rel="canonical" href="https://www.simplifyte.com/partners" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="keywords"
          content="Simplifyte partners, partner program, business partners, SaaS collaboration, partnership opportunities, become a Simplifyte partner"
        />
      </Helmet>

      <div className="Partners_main">
        <HeaderMenu />

        {/* Hero */}
        <section className="Partners_hero">
          <div className="Partners_container">
            <div className="Partners_hero_content">
              <span className="Partners_eyebrow">
                <span className="Partners_eyebrow_icon">
                  <Handshake size={12} />
                </span>
                Partner Program
              </span>

              <h1 className="Partners_heading">Let's grow, together.</h1>

              <p className="Partners_subheading">
                Partner with Simplifyte to bring work-clarity software to the
                teams you already serve — and grow your business alongside
                ours.
              </p>

              <Link to="/partnerform" className="Partners_hero_button">
                Apply Now
                <ArrowRight size={18} />
              </Link>
            </div>
          </div>
        </section>

        {/* Growth steps */}
        <section className="Partners_steps_section">
          <div className="Partners_container">
            <div className="Partners_section_header">
              <h2 className="Partners_section_title">
                Your Growth Starts Here
              </h2>
              <p className="Partners_section_subtitle">
                Join us as a Channel Partner and unlock new opportunities.
                Our simple, seamless process gets you onboarded quickly, so
                you can focus on growing your business with the right
                support.
              </p>
            </div>

            <div className="Partners_steps_grid">
              {partnersServices.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div key={index} className="Partners_step_card">
                    <div className="Partners_step_icon">
                      <Icon size={24} />
                    </div>
                    <h3 className="Partners_step_title">{item.title}</h3>
                    <p className="Partners_step_desc">{item.desc}</p>
                    <span className="Partners_step_number">{item.id}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Who we partner with */}
        <section className="Partners_who_section">
          <div className="Partners_who_bg" />
          <div className="Partners_container">
            <div className="Partners_section_header">
              <h2 className="Partners_section_title">
                The kind of people we love to partner with
              </h2>
              <p className="Partners_section_subtitle">
                If you believe in smart systems, simple tools, and scalable
                impact — you're in good company.
              </p>
            </div>

            <div className="Partners_who_grid">
              {corporateServices2.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div key={index} className="Partners_who_card">
                    <div className="Partners_who_icon">
                      <Icon size={20} />
                    </div>
                    <h3 className="Partners_who_title">{item.title}</h3>
                    <p className="Partners_who_desc">{item.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="Partners_cta_section">
          <div className="Partners_container">
            <div className="Partners_cta_box">
              <h2 className="Partners_cta_title">
                Elevate your business potential with Simplifyte.
              </h2>
              <Link to="/partnerform" className="Partners_cta_button">
                Partner Now
              </Link>
            </div>
          </div>
        </section>

        <CustomFooter />
      </div>
    </>
  );
};

export default Partners;
